import React from "react";
import LeftSide from "../components/left-side.png";
import RetailHubLogo from "../components/Union.png";
import "../loginstyle/loginPageCss.css";
import { useRef } from "react";
import { useEffect } from "react";

const ParentUiCompoent = (props) => {
  const textRef = useRef(null);

  useEffect(() => {
    let loopNum = 0;
    let isDeleting = false;
    const toRotate = [
      "Solutions",
      "Retail Audit",
      "Direct Payout",
      "Retail Census",
      "Mystery Audit",
    ];
    let txt = "";
    let period = 2000;

    const tick = () => {
      const fullTxt = toRotate[loopNum % toRotate.length];
      txt = isDeleting
        ? fullTxt.substring(0, txt.length - 1)
        : fullTxt.substring(0, txt.length + 1);

      if (textRef.current) textRef.current.innerHTML = `<span>${txt}</span>`;

      let delta = 200 - Math.random() * 100;
      if (isDeleting) delta /= 2;

      if (!isDeleting && txt === fullTxt) {
        delta = period;
        isDeleting = true;
      } else if (isDeleting && txt === "") {
        isDeleting = false;
        loopNum++;
        delta = 500;
      }

      setTimeout(tick, delta);
    };

    tick();
  }, []);

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-left">
          <img src={RetailHubLogo} alt="Top Left" className="logo-image" />

          <img src={LeftSide} alt="Retail Hub" className="leftside-image" />

          <p className="custom-text">
            India’s first Customised
            <br />
            <b ref={textRef} className="custom-text-b">
              Solutions
            </b>
            <span style={{ display: "block" }}>In-Store Solutions Company</span>
          </p>
        </div>

        <div className="login-right">{props.children}</div>
      </div>
      <div className="footer-container">
        <p className="footer-text">
          Copyright © Retail Scan Management Service Pvt Ltd {new Date().getFullYear()}
        </p>

        <div className="footer-links">
          <a
            href="https://www.retail-scan.com/terms-and-condition.html"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer">
            Terms & Conditions
          </a>

          <span> and </span>

          <a
            href="https://www.retail-scan.com/privacy-policy.html"
            className="footer-link"
            target="_blank"
            rel="noopener noreferrer">
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  );
};

export default ParentUiCompoent;
